export default "__VITE_ASSET__CK2muLb2__"